import $ from '../../helpers/legacy/jquery';

function bsAccordion() {
	const accordion = $(this);
	let defaultPanelIndex = 0;

	if (accordion.data('defaultpanel')) {
		defaultPanelIndex = Math.floor(
			$('div#' + accordion.data('defaultpanel')).index() / 2
		);
	}

	const id = accordion.attr('id');
	let activePanel = localStorage.getItem(id + '_active_panel');
	let panelIndex = defaultPanelIndex; //(activePanel == null) ? false : ((activeIndex == -1) ? 0 : Math.floor(activeIndex / 2));

	if (accordion.data('collapsed') && !$('html').hasClass('homepage')) {
		panelIndex = false;
	}

	accordion.accordion({
		collapsible: true,
		heightStyle: 'content',
		activate: function (event, ui) {
			activePanel = ui.newPanel.attr('id');
			if (activePanel !== undefined) {
				localStorage.setItem(id + '_active_panel', activePanel);
			} else {
				localStorage.removeItem(id + '_active_panel');
			}
		},
		active: panelIndex,
	});
}

// Export as jquery plugin
$.fn.bsAccordion = function () {
	return $(this).each(bsAccordion);
};

$('#service')
	.find('header.nachrichten:hidden')
	.remove()
	.end()
	.find('div#nachrichten:hidden')
	.remove();

$('.bs-accordion').not('.alwaysopen').bsAccordion();
